import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";

function OtherFees({ appData }) {
  const getPricingDataById = (id) => {
    let pricing = appData.prices.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };
  return (
    <div>
      <HeadingWithLine text="Other Fees" />
      <ul>
        <li>
          <div>
            <p>Set Up Fee</p>
            <p>{getPricingDataById(28).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Monthly Access</p>
            <p>{getPricingDataById(19).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>$100K Data Breach</p>
            <p>{getPricingDataById(42).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Monthly Minimum</p>
            <p>{getPricingDataById(18).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Semi-Annual Tech Fee</p>
            <p>{getPricingDataById(43).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Voice ARU</p>
            <p>{getPricingDataById(12).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Batch Fee</p>
            <p>{getPricingDataById(14).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>EBT Transaction</p>
            <p>{getPricingDataById(29).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>AVS Fee</p>
            <p>{getPricingDataById(13).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>3rd Party Auth/Txn</p>
            <p>{getPricingDataById(11).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>ETF Fee</p>
            <p>{getPricingDataById(46).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Chargeback Fee</p>
            <p>{getPricingDataById(20).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Representment Fee</p>
            <p>{getPricingDataById(47).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Pre-Dispute Fee</p>
            <p>{getPricingDataById(48).dollars}</p>
          </div>
        </li>
        <li>
          <div>
            <p>Returned ACH Item</p>
            <p>{getPricingDataById(22).dollars}</p>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default OtherFees;
